
import { Component, Vue, Mixins, Prop } from "vue-property-decorator";

@Component({ name: 'menu-components-Header' })
export default class Table extends Vue {
  @Prop() isChild!: boolean;
}
